export default {
  initialized: false,
  contextInitialized: false,
  isLoading: true,
  config: {},
  title: "",
  breadcrumbs: [],
  user: {},
  roles: [],
  entries: {
    default: {
      end: false,
      loadNew: 0,
      list: [],
      start: 0,
      top: {}
    },
    filter: {
      end: false,
      loadNew: 0,
      list: {},
      start: 0,
      top: {}
    },
    tag: {
      end: false,
      loadNew: 0,
      list: {},
      start: 0,
      top: {}
    }
  },
  entriesById: {},
  entriesFound: [],
  tags: [],
  tagsByMatch: {},
  adminPaneIsOpen: false,
  entryFormIsOpen: false,
  links: [],
  editMode: {},
  toasts: [],
  comments: {},
  entryComments: {},
  selectedComments: [],
  settings: {},
  tokens: [],
  drafts: [],
  draftsById: {},
  imagesLoaded: {},
  filters: [],
  filterRules: [],
  progress: 0,
  showProgressBar: false,
  sessToken: "",
  authToken: "",
  roleRights: [],
  tagRoles: [],
  overlayIsOpen: false,
  imageSizes: [],
  context: [],
  contextHistory: [],
  contextSynced: [],
  settingsConfig: [],
  banners: [],
  header: {},
  blocks: [],
  blocksById: {},
  imageLink: {}
};
